/* Intelligentsia speech bubble — ported from the prototype's bubble(). */
import React from 'react';

export default function Bubble({ children }) {
	return <div className="bubble">✦ {children}</div>;
}
